import gql from 'graphql-tag';

export default gql`
  fragment blastengineMailCampaignMailBounceProspectActivityFragment on BlastengineMailCampaignMailBounceProspectActivity {
    id
    mailCampaignSend {
      id
      createdAt
      mailCampaign {
        id
        uuid
        title
        subject
        fromAddress
        fromName
        cc
        bcc
        sendAt
        isImmediately
        bodyHtml
        pool {
          uuid
        }
      }
    }
  }
`;
